import React from "react";

const UserContext = React.createContext<any>(null);

export default UserContext;
